import { getActionFromUrl } from "./initializer";
import { addBootgridData } from "./addBootgridData";
import { luscinia } from "./luscinia";
import { injectWizardStateToForm } from "./wizardStateHelpers";

luscinia.renderParameter = function (parameterFullName, paramData, allowNullValues) {
    let url = "/parameter/render/" + parameterFullName;
    if (allowNullValues !== undefined) {
        url += "?allowNullValues=" + allowNullValues;
    }
    $.ajax({
        method: "Post",
        url: url,
        data: paramData,
        success: function (data) {
            var contentSelector = luscinia.parameter.identifier.parameterContent;
            $(contentSelector).replaceWith(data);
            var form = $(contentSelector).closest("form");
            luscinia.initFormElements(form, $(contentSelector)).then(function () {
                 var formData = luscinia.serializeFormObject($(form));
                 $.ajax({
                     method: "POST",
                     processData: false,
                     contentType: false,
                     url: "/parameter/afteropen/" + parameterFullName,
                     data: formData
                 }).done(function (actions) {
                     luscinia.executeActionList(actions, form, false);
                 });
            });
        }
    });
};

luscinia.renderEmailParameter = function (parameterFullName, urlExtension?: string) {
    const url = `/parameter/email/${luscinia.getModalLayerCount()}/${parameterFullName}` + urlExtension ?? "";
    $.get(url, function (data) {
        $("#cl-wrapper").append(data);
        
        var form = luscinia.getActiveForm();
        var modal = luscinia.getCurrentModal();
        var modalIdentifier = "#" + modal.attr("id");
        luscinia.initModalDialog(form, modalIdentifier, luscinia.config, getActionFromUrl(url), modalIdentifier).then(function () {
            var formData = luscinia.serializeFormObject(form);
            $.ajax({
                method: "POST",
                processData: false,
                contentType: false,
                url: "/parameter/afteropen/" + parameterFullName,
                data: formData
            }).done(function (actions) {
                luscinia.executeActionList(actions, form, false);
            });
        });
        $(modalIdentifier).modal("show");
    });
};

luscinia.renderReportParameter = function (parameterFullName: string, reportName: string, filterObjectId: string, serializedParameter: string, onConfirmJs?: string) {
    let url = `/parameter/report/${luscinia.getModalLayerCount()}/${parameterFullName}?reportName=${encodeURIComponent(reportName)}&filterObjectId=${encodeURIComponent(filterObjectId)}&serializedParameter=${encodeURIComponent(serializedParameter)}`;
    if (onConfirmJs) {
        url += `&onConfirmJs=${onConfirmJs}`; // already URL-encoded from the server
    }
    $.get(url, function (data) {
        $("#cl-wrapper").append(data);

        var form = luscinia.getActiveForm();
        var modal = luscinia.getCurrentModal();
        var modalIdentifier = "#" + modal.attr("id");
        luscinia.initModalDialog(form, modalIdentifier, luscinia.config, getActionFromUrl(url), modalIdentifier).then(function () {
            var formData = luscinia.serializeFormObject(form);
            $.ajax({
                method: "POST",
                processData: false,
                contentType: false,
                url: "/parameter/afteropen/" + parameterFullName,
                data: formData
            }).done(function (actions) {
                luscinia.executeActionList(actions, form, false);
            });
        });
        $(modalIdentifier).modal("show");
    });
};

luscinia.renderActionParameter = function (parameterFullName: string, actionName: string, moduleType: string, serializedParameter: string, modalTitle?: string) {
    let url = `/parameter/action/${luscinia.getModalLayerCount()}/${parameterFullName}?actionName=${encodeURIComponent(actionName)}&moduleType=${encodeURIComponent(moduleType)}&serializedParameter=${encodeURIComponent(serializedParameter)}`;
    if (modalTitle) {
        url += `&modalTitle=${encodeURIComponent(modalTitle)}`;
    }

    $.get(url, function (data) {
        $("#cl-wrapper").append(data);

        const form = luscinia.getActiveForm();
        const modal = luscinia.getCurrentModal();
        const modalIdentifier = "#" + modal.attr("id");
        modal.on("hidden.bs.modal", function (e) {
            $(e.target).remove();
        });
        luscinia.initModalDialog(form, modalIdentifier, luscinia.config, getActionFromUrl(url), modalIdentifier);
        $(modalIdentifier).modal("show");
    });
};

luscinia.submitReportParameterForm = function (event) {
    event.preventDefault();

    let frmSelector = "#editModal" + (luscinia.getModalLayerCount() - 1) + "Form";
    let frm = $(frmSelector) as JQuery<HTMLFormElement>;
    var formData = luscinia.serializeFormObject(frm);

    let url = frm.attr("data-url").toString();
    $.ajax({
        method: "POST",
        url: url,
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        success: function (actions) {
            luscinia.executeActionList(actions, frm, false);
        },
        error: function (jqXHR) {
            let errorMessageOrErrorList = jqXHR.responseJSON !== undefined ? jqXHR.responseJSON : jqXHR.responseText;
            luscinia.refreshValidation(errorMessageOrErrorList, frm, frmSelector);
        }
    });
};

luscinia.submitActionParameterForm = function (sender: HTMLElement) {
    const modal = $(sender).closest(".modal");
    const form = modal.find("form") as JQuery<HTMLFormElement>;
    const actionName = form.data("action-name") as string;
    const moduleType = form.data("module-type") as string;
    let activeForm: JQuery<HTMLFormElement>;
    if (moduleType === "WizardModule") {
        activeForm = $(".block-wizard").find("form") as JQuery<HTMLFormElement>;
    }
    else {
        const currentModal = luscinia.getCurrentModal();
        const parentModal = currentModal.prevAll(".edit-modal").first();
        activeForm = parentModal.find("form") as JQuery<HTMLFormElement>;
        if (activeForm.length === 0) {
            activeForm = luscinia.getActiveForm();
        }
    }

    const formData = luscinia.serializeFormObject(activeForm);
    if (moduleType === "WizardModule") {
        addBootgridData(formData, activeForm);
        injectWizardStateToForm(formData);
    }

    const parameterFormData = luscinia.serializeFormObject(form);
    for (const pair of parameterFormData.entries()) {
        formData.append(pair[0], pair[1]);
    }

    let url = "";
    if (moduleType === "WizardModule") {
        const wizardForm = $(".block-wizard").find("form") as JQuery<HTMLFormElement>;
        const parameterName = $(".block-wizard").data("parameter");
        const stepName = $(".block-wizard").find(".steps").find("li.active").data("stepname");
        url = `/wizard/${parameterName}/action/${stepName}/${actionName}`;
        if (wizardForm.length === 0) {
            throw new Error("Wizard form not found");
        }
    }
    else {
        const modulePath = activeForm.data(luscinia.data.modulePath) as string;
        url = `${modulePath}/action/${actionName}`;
    }

    $.ajax({
        method: "POST",
        cache: false,
        contentType: false,
        processData: false,
        url: url,
        data: formData
    }).done(function (actions: any) {
        const currentModal = luscinia.getCurrentModal();
        if (currentModal.length > 0) {
            currentModal.on("hidden.bs.modal", function () {
                currentModal.remove();
            });
            currentModal.modal("hide");
        }
        luscinia.executeActionList(actions, activeForm, false);
    });
};

luscinia.resetPinCode = function (parameterFullName) {
    $.get(`/parameter/resetPinCode/${luscinia.getModalLayerCount()}/${parameterFullName}`, function (data) {
        var modalIdentifier = "#editModal" + luscinia.getModalLayerCount();
        $("#cl-wrapper").append(data);
        luscinia.initModalDialog($(modalIdentifier + "Form"), modalIdentifier, luscinia.config, modalIdentifier);
        $(modalIdentifier).modal("show");
    });
};